// Sidebar.jsx - FIXED (no ChatContext dependency)
import React, { useState } from 'react';

function Sidebar({ 
  chats, 
  currentChatId, 
  onChatSelect, 
  onChatDelete, 
  onChatRename,
  onNewChat,
  isOpen,
  onToggle
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [editingChatId, setEditingChatId] = useState(null);
  const [editTitle, setEditTitle] = useState('');

  const filteredChats = chats.filter(chat =>
    chat.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startEditing = (chat) => {
    setEditingChatId(chat.id);
    setEditTitle(chat.title);
  };

  const saveEdit = () => {
    if (editTitle.trim()) {
      onChatRename(editingChatId, editTitle.trim());
    }
    setEditingChatId(null);
  };

  const cancelEdit = () => {
    setEditingChatId(null);
    setEditTitle('');
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <button className="new-chat-btn" onClick={onNewChat}>
          + New Chat
        </button>
      </div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search chats..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="chats-list">
        {filteredChats.map(chat => (
          <div
            key={chat.id}
            className={`chat-item ${chat.id === currentChatId ? 'active' : ''}`}
          >
            {editingChatId === chat.id ? (
              <div className="chat-edit">
                <input
                  type="text"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') saveEdit();
                    if (e.key === 'Escape') cancelEdit();
                  }}
                  autoFocus
                />
                <button onClick={saveEdit}>✓</button>
                <button onClick={cancelEdit}>✕</button>
              </div>
            ) : (
              <>
                <div 
                  className="chat-content"
                  onClick={() => onChatSelect(chat.id)}
                >
                  <div className="chat-title">{chat.title}</div>
                  <div className="chat-date">
                    {new Date(chat.updatedAt).toLocaleDateString()}
                  </div>
                </div>
                <div className="chat-actions">
                  <button
                    className="chat-action-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      startEditing(chat);
                    }}
                    title="Rename"
                  >
                    ✏️
                  </button>
                  <button
                    className="chat-action-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm('Delete this chat?')) {
                        onChatDelete(chat.id);
                      }
                    }}
                    title="Delete"
                  >
                    🗑️
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Sidebar;
